import { gql } from '@apollo/client';

export const getLink = gql`
  mutation Purchase($payLoad: PurchaseInput) {
    getPaymentLink(input: $payLoad) {
      paymentUrl
    }
  }
`;

export const getVipPacks = gql`
  query GetVIPPacks {
    getVipPacks {
      vip2Config {
        price
      }
    }
  }
`;
